export const defaultPaginatedStateOptions = {
	"page[size]": 200,
	"page[number]": 1
};
